<template>
  <div>
    <div class="d-flex justify-content-center">
      <img src="@/assets/rewards-image-dark-m.jpg"  class="background-img d-block d-sm-block d-md-block d-lg-none d-xl-none">
      <img src="@/assets/rewards-image-dark.jpg"  class="background-img d-none d-sm-none d-md-none d-lg-block d-xl-block">
    </div>
    <div class="background">
        <div class="container">
          <div class="c2">
            <h1 class="title mb-3">Retrieve your Rewards card number</h1>
            <p class="text pb-3 mb-3">Enter the email address linked to your account and we'll send you an email with your Rewards card number. </p>
            <label class="label mb-1">Email Address</label>
            <input class="form-control input-field pb-3 mb-3 pl-4" v-model="emailAddress">
            <div class="d-flex justify-content-center">
              <button type="submit" class="btn btn-primary green-btn" v-on:click="setEmailReminder">
                  <div v-if="showLoader" class="spinner-border white-spinner" role="status" aria-label="Spinning">
                      <span class="visually-hidden">Loading...</span>
                  </div>
                <div v-if="!showLoader">Send Email</div>
              </button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script setup>
    import { ref } from 'vue'
    import { useRouter } from 'vue-router'
    import digitalApi from '@/services/DigitalApiClient.js'

    const emailAddress = ref('')
    const showLoader = ref(false)
    const router = useRouter()

    async function setEmailReminder() {
        if (!emailAddress.value) {
            router.push({ path: '/en-gb' })
            return
        }

        showLoader.value = true
        try {
            const result = await digitalApi.setEmailReminder(emailAddress.value)
            if (result === 204) {
                router.push({ name: 'RetrieveRewardsConfirm', params: { email: emailAddress.value } })
            }
            // Optionally handle other result codes (e.g., 500)
        } finally {
            showLoader.value = false
        }
    }
</script>

<style lang="scss" scoped>
  @import '@/scss/_retrieve-rewards-card.scss';
</style>
